import { render } from "./bottom.vue?vue&type=template&id=6197829b&scoped=true&ts=true"
import script from "./bottom.vue?vue&type=script&lang=ts"
export * from "./bottom.vue?vue&type=script&lang=ts"

import "./bottom.vue?vue&type=style&index=0&id=6197829b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6197829b"]])

export default __exports__